export type CarePlanPosition = {
  unit: 'day' | 'week' | 'month';
  value: number;
};

const AVERAGE_DAYS_PER_MONTH = 30.44;

/**
 * Where a recurring care-plan occurrence sits in the plan timeline, derived
 * from its day number (calendar days from the event date, Day 0) and the
 * recurrence cadence. Null when the task is outside a plan, has no cadence,
 * or falls before the event (pre-event occurrences carry no position badge).
 */
export const getCarePlanPosition = (
  recurrenceType: string | undefined,
  dayNumber: number | null | undefined,
): CarePlanPosition | null => {
  if (dayNumber == null || dayNumber < 0 || !recurrenceType) return null;

  if (recurrenceType === 'WEEKLY') 
    return { unit: 'week', value: Math.max(1, Math.ceil(dayNumber / 7)) };

  if (recurrenceType === 'MONTHLY') {
    // Monthly recurrences advance by calendar months (28-31 days apart):
    // rounding against the average month length maps each occurrence to its
    // month index regardless of the drift.
    return {
      unit: 'month',
      value: Math.max(1, Math.round(dayNumber / AVERAGE_DAYS_PER_MONTH)),
    };
  }

  return { unit: 'day', value: dayNumber };
};
